/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Season_BlockersInputs */

const en_nav_season_blockers = /** @type {(inputs: Nav_Season_BlockersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What blocks the season`)
};

/**
* | output |
* | --- |
* | "What blocks the season" |
*
* @param {Nav_Season_BlockersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_season_blockers = /** @type {((inputs?: Nav_Season_BlockersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Season_BlockersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_season_blockers(inputs)
});